import { Camera, KeyRound, Mail, Scale, Split, FlaskConical, Gauge, Map as MapIcon, ShieldAlert, ShieldCheck } from "lucide-react";
import { INTEGRATION_TAB_PERM as P } from "../perms";
import type { SubsectionTab } from "../subsection";
import { AriregisterCard } from "./AriregisterCard";
import { OpenDataLicenceCard } from "./OpenDataLicenceCard";
import { MapsCard } from "./MapsCard";
import { BrowserRenderingCard } from "./BrowserRenderingCard";
import { WebRiskCard } from "./WebRiskCard";
import { PagespeedCard } from "./PagespeedCard";
import { WordfenceCard } from "./WordfenceCard";
import { MailIntegrationCard } from "./MailIntegrationCard";
import { MailChannelsCard } from "./MailChannelsCard";
import { TestModeCard } from "./TestModeCard";

/**
 * Order is the order somebody sets the CRM up in: the register first (it feeds
 * every company record) and, directly under it, the licence its free files are
 * kept under - because the import refuses to run until that one is answered,
 * which makes it the first thing rather than a footnote. Then the map that
 * draws those same records, then the browser that goes out and looks at their
 * websites, then the blocklist that says whether somebody else already calls
 * one of those sites dangerous - the last two things that read a prospect
 * before anybody writes to one. Then the two keys Saidiseire's slow jobs use
 * on our own customers' sites (PageSpeed for the speed test, Wordfence for
 * the vulnerability feed), next to the blocklist because they are the same
 * kind of thing: an outside service that looks at a website for us. Then
 * mail, which is how we reach the companies all of them found. Test mode sits directly under
 * the two mail tabs because it is the third question about the same thing - who
 * a message actually reaches - and burying it further down would hide the one
 * switch that stops a half-built feature writing to a real client.
 *
 * The phone stack used to continue this list. It is `../phone/tabs.ts` now, and
 * card payments - the one entry here that was ever about money coming IN rather
 * than about finding or reaching a company - is `../payments/tabs.ts`.
 */
// The permissions are referenced, not typed in. They live in `../perms` beside
// every other Settings gate, because `crm/nav.ts` reads the same list to decide
// whether Settings appears at all and cannot import this file - that would pull
// four panels into the sidebar's module graph.
export const INTEGRATION_TABS: SubsectionTab[] = [
  { path: "ariregister", key: "ariregister", icon: KeyRound, perm: P.ariregister, panel: AriregisterCard },
  { path: "open-data", key: "openData", icon: Scale, perm: P["open-data"], panel: OpenDataLicenceCard },
  { path: "maps", key: "maps", icon: MapIcon, perm: P.maps, panel: MapsCard },
  { path: "browser", key: "browser", icon: Camera, perm: P.browser, panel: BrowserRenderingCard },
  { path: "web-risk", key: "webRisk", icon: ShieldAlert, perm: P["web-risk"], panel: WebRiskCard },
  { path: "pagespeed", key: "pagespeed", icon: Gauge, perm: P.pagespeed, panel: PagespeedCard },
  { path: "wordfence", key: "wordfence", icon: ShieldCheck, perm: P.wordfence, panel: WordfenceCard },
  { path: "mail", key: "mail", icon: Mail, perm: P.mail, panel: MailIntegrationCard },
  { path: "channels", key: "channels", icon: Split, perm: P.channels, panel: MailChannelsCard },
  { path: "test-mode", key: "testMode", icon: FlaskConical, perm: P["test-mode"], panel: TestModeCard },
];
